import { React, useState, useEffect, useRef } from "react";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import InputIcon from "react-multi-date-picker/components/input_icon";
import ReCAPTCHA from "react-google-recaptcha";
import { useReserve } from "../../../hooks/apis/reserve";
import { toast } from "react-toastify";

function Reserve_form() {
  const { mutate, data, isSuccess, isLoading, isError } = useReserve();

  const [date, setDate] = useState();
  const [loading, setLoading] = useState(false);

  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
  };

  const nameRef = useRef();
  const phoneRef = useRef();
  const countRef = useRef();
  const descRef = useRef();
  const recaptchaRef = useRef();

  function toEnglishDigits(str) {
    // convert persian digits [۰۱۲۳۴۵۶۷۸۹]
    var e = "۰".charCodeAt(0);
    str = str.replace(/[۰-۹]/g, function (t) {
      return t.charCodeAt(0) - e;
    });

    // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
    e = "٠".charCodeAt(0);
    str = str.replace(/[٠-٩]/g, function (t) {
      return t.charCodeAt(0) - e;
    });
    return str;
  }

  function handleDate(value) {
    setDate(value ? toEnglishDigits(value.format("YYYY-MM-DD HH:00")) : "");
  }

  const [inputErrors, setInputErrors] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);

  let handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    setInputErrors({});

    if (nameRef.current.value === "") {
      setInputErrors((prevState) => ({
        ...prevState,
        lastNameError: "لطفا نام و نام خانوادگی خود را وارد کنید",
      }));
    } else if (nameRef.current.value.length > 50) {
      setInputErrors((prevState) => ({
        ...prevState,
        lastNameError: "نام و نام خانوادگی شما نباید بیشتر از 50 کاراکتر باشد",
      }));
    } else {
      setInputErrors((prevState) => ({
        ...prevState,
        lastNameError: "",
      }));
    }

    if (date == undefined) {
      setInputErrors((prevState) => ({
        ...prevState,
        dateError: "لطفا تاریخ رزرو خود را وارد کنید",
      }));
    } else {
      setInputErrors((prevState) => ({
        ...prevState,
        dateError: "",
      }));
    }

    if (phoneRef.current.value === "") {
      setInputErrors((prevState) => ({
        ...prevState,
        phoneError: "لطفا  شماره تماس  خود را وارد کنید",
      }));
    } else if (phoneRef.current.value.length > 11) {
      setInputErrors((prevState) => ({
        ...prevState,
        phoneError: "لطفا شماره تماس خود رادرست وارد کنید",
      }));
    } else {
      setInputErrors((prevState) => ({
        ...prevState,
        phoneError: "",
      }));
    }

    if (countRef.current.value === "") {
      setInputErrors((prevState) => ({
        ...prevState,
        countError: "لطفا  تعداد نفرات خود را وارد کنید",
      }));
    } else {
      setInputErrors((prevState) => ({
        ...prevState,
        countError: "",
      }));
    }

    if (descRef.current.value === "") {
      setInputErrors((prevState) => ({
        ...prevState,
        descError: "لطفا توضیحات  خود را وارد کنید",
      }));
    } else if (descRef.current.value.length > 250) {
      setInputErrors((prevState) => ({
        ...prevState,
        descError: " توضیحات  شما نباید بیشتر از 250 کاراکتر باشد",
      }));
    } else {
      setInputErrors((prevState) => ({
        ...prevState,
        descError: "",
      }));
    }

    if (!recaptchaValue) {
      setInputErrors((prevState) => ({
        ...prevState,
        captchaError: "لطفا کپچا را وارد کنید",
      }));
    } else {
      setInputErrors((prevState) => ({
        ...prevState,
        captchaError: "",
      }));
    }
  };

  useEffect(() => {
    const hasLastNameError = !!inputErrors.lastNameError;
    const hasDateError = !!inputErrors.dateError;
    const hasPhoneError = !!inputErrors.phoneError;
    const hasCountError = !!inputErrors.countError;
    const hasDescError = !!inputErrors.descError;
    const hasRecaptchaError = !!inputErrors.captchaError;

    if (
      formSubmitted &&
      !hasLastNameError &&
      !hasDateError &&
      !hasPhoneError &&
      !hasCountError &&
      !hasDescError &&
      !hasRecaptchaError
    ) {
      setLoading(true);
      const body = {
        "reserve-name": nameRef.current.value,
        "reserve-date": date,
        "reserve-phone": phoneRef.current.value,
        "reserve-count": countRef.current.value,
        "reserve-desc": descRef.current.value,
        "reserve-captcha": recaptchaValue,
      };
      mutate(body);
    }
  }, [inputErrors, formSubmitted]);

  useEffect(() => {
    if (isSuccess) {
      setLoading(false);
      toast.success("رزرو میز شما با موفقیت انجام شد");
    } else if (isError) {
      setLoading(false);
      toast.error("خطایی  به وجود امده است لطفا دوباره تلاش کنید");
    }
  }, [isSuccess, isError]);
  return (
    <div className="reserve-form">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-12 m-auto">
            <div className={loading ? "active loading" : "loading"}>
              <img
                src={process.env.PUBLIC_URL + "/images/loading.svg"}
                className="img-fluid"
              />
            </div>
            <form onSubmit={handleSubmit} className="form">
              <div className="reserve_form">
                <div className="form-item">
                  <label htmlFor="reserve-name" className="form-item__label">
                    نام و نام خانوادگی
                  </label>
                  <input
                    type="text"
                    name="reserve-name"
                    id="reserve-name"
                    className="form-item__input"
                    ref={nameRef}
                  />
                  {inputErrors.lastNameError ? (
                    <span style={{ color: "red", fontSize: "10px" }}>
                      {inputErrors.lastNameError}
                    </span>
                  ) : null}
                </div>
                <div className="form-item">
                  <label htmlFor="reserve-date" className="form-item__label">
                    تاریخ رزرو
                  </label>
                  <DatePicker
                    plugins={[<TimePicker position="bottom" hideSeconds />]}
                    render={<InputIcon />}
                    format="YYYY-MM-DD HH:00"
                    calendar={persian}
                    locale={persian_fa}
                    calendarPosition="bottom-right"
                    minDate={new Date()}
                    editable={false}
                    value={date}
                    onChange={handleDate}
                  />

                  {inputErrors.dateError ? (
                    <span style={{ color: "red", fontSize: "10px" }}>
                      {inputErrors.dateError}
                    </span>
                  ) : null}
                </div>
                <div className="form-item">
                  <label htmlFor="reserve-phone" className="form-item__label">
                    شماره تماس
                  </label>
                  <input
                    type="tel"
                    name="reserve-phone"
                    id="reserve-phone"
                    className="form-item__input"
                    ref={phoneRef}
                  />
                  {inputErrors.phoneError ? (
                    <span style={{ color: "red", fontSize: "10px" }}>
                      {inputErrors.phoneError}
                    </span>
                  ) : null}
                </div>
                <div className="form-item">
                  <label htmlFor="reserve-count" className="form-item__label">
                    تعداد
                  </label>
                  <input
                    type="number"
                    name="reserve-count"
                    id="reserve-count"
                    min="1"
                    step="1"
                    className="form-item__input"
                    ref={countRef}
                  />
                  {inputErrors.countError ? (
                    <span style={{ color: "red", fontSize: "10px" }}>
                      {inputErrors.countError}
                    </span>
                  ) : null}
                </div>
                <div className="form-item">
                  <label htmlFor="reserve-desc" className="form-item__label">
                    توضیحات
                  </label>
                  <textarea
                    name="reserve-desc"
                    id="reserve-desc"
                    className="form-item__textarea"
                    rows="6"
                    ref={descRef}
                  ></textarea>
                  {inputErrors.descError ? (
                    <span style={{ color: "red", fontSize: "10px" }}>
                      {inputErrors.descError}
                    </span>
                  ) : null}
                </div>
                <div className="form-item align-items-center">
                  <ReCAPTCHA
                    sitekey="6LcwDZ8lAAAAAEpTik2KnKiiXgPhblC62oOWgo86"
                    ref={recaptchaRef}
                    onChange={handleRecaptchaChange}
                  />
                  {inputErrors.captchaError ? (
                    <span style={{ color: "red", fontSize: "10px" }}>
                      {inputErrors.captchaError}
                    </span>
                  ) : null}
                </div>
                <div className="form-item">
                  <button
                    type="submit"
                    name="reserve-submit"
                    id="reserve-submit"
                    className="form-item__submit"
                  >
                    رزرو میز
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Reserve_form;
